import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { GetProductsRequest, GetProductsResponse, Product, SaveProductRequest, SaveProductResponse } from '@models'

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private readonly baseUrl = `${environment.api.baseUrl}/product-structure/v1/products`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetProductsRequest): Promise<GetProductsResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

      if (params.order) httpParams = httpParams.set('order', params.order)

      if (params.text) httpParams = httpParams.set('text', params.text)
    }

    const response = await firstValueFrom(this.http.get<GetProductsResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<Product> {
    const response = await firstValueFrom(this.http.get<Product>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveProductRequest): Promise<SaveProductResponse> {
    const response = await firstValueFrom(this.http.post<SaveProductResponse>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveProductRequest): Promise<SaveProductResponse> {
    const response = await firstValueFrom(this.http.put<SaveProductResponse>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
